import { type ReactNode } from 'react';
import { Stack, Text, ThemeIcon, Button } from '@mantine/core';
import { IconInbox } from '@tabler/icons-react';

interface PortalEmptyStateProps {
  icon?: ReactNode;
  title: string;
  description?: string;
  actionLabel?: string;
  onAction?: () => void;
}

export function PortalEmptyState({
  icon,
  title,
  description,
  actionLabel,
  onAction,
}: PortalEmptyStateProps) {
  return (
    <Stack align='center' justify='center' gap='md' py='xl' px='md'>
      <ThemeIcon size={64} radius='xl' variant='light' color='gray'>
        {icon ?? <IconInbox size={32} />}
      </ThemeIcon>
      <Text fw={600} size='lg' ta='center'>
        {title}
      </Text>
      {description && (
        <Text size='sm' c='dimmed' ta='center' maw={320}>
          {description}
        </Text>
      )}
      {actionLabel && onAction && (
        <Button variant='light' onClick={onAction} style={{ minHeight: 44 }} mt='xs'>
          {actionLabel}
        </Button>
      )}
    </Stack>
  );
}
